module.exports = __webpack_public_path__ + "media/images/front/pc/routable/banner01-8049767a868a120da821a1ea77a7b6c1.png";